import { render, staticRenderFns } from "./FiltrosObrasAutorizadas.vue?vue&type=template&id=2d32142a&scoped=true&"
import script from "./FiltrosObrasAutorizadas.vue?vue&type=script&lang=js&"
export * from "./FiltrosObrasAutorizadas.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosObrasAutorizadas.vue?vue&type=style&index=0&id=2d32142a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32142a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VIcon,VProgressCircular,VRow})
